import { APISubscription } from '../../../../typings/Subscription.interface';

export const isFreePlan = (plan: APISubscription['plan']) => {
  return plan.startsWith('free');
};
